import { Module } from 'vuex-smart-module';
import CartActions from './actions';
import CartGetters from './getters';
import CartMutations from './mutations';
import CartState from './state';
import CartHistory from './modules/cart-history';
import CartDetail from './modules/cart-detail';

export default new Module({
  state: CartState,
  mutations: CartMutations,
  actions: CartActions,
  getters: CartGetters,
  modules: {
    cart_history: CartHistory,
    cart_detail: CartDetail,
  },
});
